/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  ForbiddenResponse,
  GetDiscrepancyListParams,
  GetDiscrepancyListResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Discrepancy List
 */
export const getDiscrepancyList = (params?: GetDiscrepancyListParams, signal?: AbortSignal) => {
  return customInstance<GetDiscrepancyListResponseResponse>({
    url: `/bm-declaration-service/v1/discrepancy`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetDiscrepancyListQueryKey = (params?: GetDiscrepancyListParams) => {
  return [`/bm-declaration-service/v1/discrepancy`, ...(params ? [params] : [])] as const;
};

export const getGetDiscrepancyListQueryOptions = <
  TData = Awaited<ReturnType<typeof getDiscrepancyList>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  params?: GetDiscrepancyListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscrepancyList>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDiscrepancyListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiscrepancyList>>> = ({ signal }) =>
    getDiscrepancyList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDiscrepancyList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDiscrepancyListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDiscrepancyList>>
>;
export type GetDiscrepancyListQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Discrepancy List
 */
export const useGetDiscrepancyList = <
  TData = Awaited<ReturnType<typeof getDiscrepancyList>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  params?: GetDiscrepancyListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscrepancyList>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDiscrepancyListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
